"use client";

import {useOrg} from "@/hooks/useOrg";
import {createSharedApprovalLookup} from "./createSharedApprovalLookup";
import {fetchUseCasesBatch} from "@/utils/scripts/liveReflectionData";

const useNames = createSharedApprovalLookup(async key => {
   const [, ids] = JSON.parse(key) as [string, string[]];
   const records = await fetchUseCasesBatch(ids, true);
   return new Map([...records].filter(([, record]) => record.title?.trim()).map(([id, record]) => [id, record.title]));
});

/** Batch unresolved associations and share identical requests within the current organization. */
export function useApprovalUseCaseNames(ids: readonly string[]) {
   const {org} = useOrg();
   const uniqueIds = [...new Set(ids)].sort((a, b) => a.localeCompare(b));
   return useNames(org?.id && uniqueIds.length ? JSON.stringify([org.id, uniqueIds]) : null);
}
